import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from "react";
import { clsx } from 'clsx';
function _FilterLight(props, ref) {
    const { className, ...rest } = props;
    const classes = clsx('go-icon', className);
    return _jsx("span", { className: classes, ref: ref, ...rest, children: _jsxs("svg", { width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", children: [_jsx("path", { stroke: "currentColor", strokeLinecap: "round", d: "M5 12V4M19 20v-3M5 20v-4M19 13V4M12 7V4M12 20v-9" }), _jsx("circle", { cx: 5, cy: 14, r: 2, stroke: "currentColor", strokeLinecap: "round" }), _jsx("circle", { cx: 12, cy: 9, r: 2, stroke: "currentColor", strokeLinecap: "round" }), _jsx("circle", { cx: 19, cy: 15, r: 2, stroke: "currentColor", strokeLinecap: "round" })] }) });
}
const FilterLight = forwardRef(_FilterLight);
export { FilterLight };
